import React from 'react';

import FormTitle from 'components/shared/Typography/FormTitle';

import { ITINERARIES_ITEM_TO_LABEL_MAP, ITINERARIES_ITEM_TO_SHARING_MODAL_MAP } from '../../constants';
import Recipients from '../../Content/ShareViaEmail/Recipients';

function Contacts(props) {
  const { push, shareWithType, itinerariesItemType } = props;
  const SHARING_MODAL = ITINERARIES_ITEM_TO_SHARING_MODAL_MAP[itinerariesItemType];

  return (
    <>
      <FormTitle
        hint={
          SHARING_MODAL[shareWithType].what ||
          `Enter all ${SHARING_MODAL[shareWithType].who} you would like to share this ${ITINERARIES_ITEM_TO_LABEL_MAP[itinerariesItemType]} with.`
        }
      >
        {SHARING_MODAL[shareWithType].who}
      </FormTitle>
      <Recipients push={push} name="clients" />
    </>
  );
}

export default Contacts;
